import {has} from 'lodash';

export class NoShow {
    hasNs: boolean = false;
    type: boolean = false;
    nbr: number = 0;
    public bindingData(data) {
        if (has(data, 'show')) {
            this.hasNs = true;
            this.type = data.show.type;
            this.nbr = data.show.nbr
        }
        return this;
    }

    /**
     * tes si c pour la 1 nuit de la resrvation
     * @returns boolean
     */
    isFierstNight(): boolean {
        return this.type;
    }

    /**
     * tes si c pour toute la resrvation
     * @returns boolean
     */
    isBooking(): boolean {
        return !this.type;
    }

}